import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';

@Component({
  selector: 'say-toggle-box',
  templateUrl: './toggle-box.component.html',
  styleUrls: ['./toggle-box.component.scss']
})
export class ToggleBoxComponent implements OnInit {

  constructor() { }

  /**The HTML elements unique Identifier, used for integration testing */
  @Input() inputId: string;
  /**The name of the state (IE. Loading, None, Text, Email, All etc) */
  @Input() name: string;
  /**True if the checkbox should be checked, otherwise false */
  @Input() checked: boolean = false;
  /**True if the checkbox is pending change due to an API call, otherwise false */
  @Input() loading: boolean = false;
  /**True if the toggle hasn't been changed since load, otherwise false   */
  @Input() firstLoad: boolean = false;//Used to reduce the loading animation
  /**Denies the switch from being turned off by a user interaction */
  @Input() denyTurnOff: boolean = false;
  /**Denies the switch from being turned off or on by a user interaction */
  @Input() disable: boolean = false;
  /**Change emitter everytime the user adjusts the toggle box */
  @Output() checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  /**Reference to the HTML checkbox input */
  @ViewChild('checkbox', { static: true }) checkbox: ElementRef;

  /**The current state of the toggle box, 0 - Off, 1 - Loading, 2 - On */
  public currentState: ToggleState = ToggleState.Off;

  /**Handles initialization logic, sets the current state of the check box */
  ngOnInit() {
    this.currentState = this.getState();
  }

  /**
   * Tracks user interactions, sets state after user interacts
   * @param changes The changes to this components Input fields
   */
  ngOnChanges(changes: SimpleChanges): void {
    this.currentState = this.getState();
  }

  /**
   * Fires on every user interaction (checkbox click)
   */
  public swapValue(): void {
    if (!this.checked || !this.denyTurnOff) {//if already unchecked or allowed to be unchecked
      this.checked = !this.checked;
      this.checkedChange.emit(this.checked);
    }
  }

  /**
   * Gets the current state of the toggle.
   *  - 0: off
   *  - 1: loading (waiting for API response)
   *  - 2: on
   */
  //Explanation: The animation used inside this component needs a numerical state to coincide with the HTML element child, 
  //this method converts logical states to numerical ones.
  private getState(): ToggleState {
    if (this.checked && !this.loading) {
      return ToggleState.On;
    } else if (this.loading) {
      return ToggleState.Loading;
    } else {
      return ToggleState.Off;
    }
  }
}

enum ToggleState {
  Off = 0,
  Loading = 1,
  On = 2
}
